export default function ToastPlugin() {
  var createInfoToasterMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
  return {
    commands: {
      openToast: function openToast(editor, toastOptions) {
        return createInfoToasterMessage(toastOptions);
      }
    }
  };
}